import { SubmitPaymentsDTO } from '../@types/SubmitPaymentsDTO'
import { apiClient } from '@src/services/http-common'
import { useMutation } from '@tanstack/react-query'

const submitPaymentSpread = async (paymentData: SubmitPaymentsDTO) => {
  const { loanId, ...data } = paymentData
  const url = `/Loans/${loanId}/Payments/Spread`
  const response = await apiClient.post<SubmitPaymentsDTO>(url, data)
  return response.data
}

export const usePostPaymentSpread = () => {
  const { mutateAsync, isPending, reset } = useMutation({
    mutationFn: submitPaymentSpread,
  })

  return [mutateAsync, isPending, reset] as const
}
